import axios from '@/libs/api.request'
// 查询tbc状态(待确认)下的mentor request
export const getMrTbc = data => {
  return axios.request({
    url: '/mr/tbc',
    data,
    method: 'POST'
  })
}
// 选择确认导师
export const getMrConfirm = data => {
  return axios.request({
    url: '/mr/confirm',
    data,
    method: 'POST'
  })
}
